import { Components, Theme } from "@mui/material/styles"

const Tooltip = (theme: Theme): Components => {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#383B40",
          color: "#FFFFFF",
          boxShadow: theme.shadows[1],
          fontSize: 11,
        },
        arrow: {
          color: "#383B40",
        },
      },
    },
  }
}

export default Tooltip
